<template>
  <div class="p-4">
    <div class="loader-overlay" v-if="isDataFetch">
      <b-spinner
        style="width: 3rem; height: 3rem"
        type="grow"
        class="text-white"
      ></b-spinner>
    </div>

    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-6 text-left">
            <h4>Employers</h4>
          </div>
          <div class="col-6 text-right">
            <ModalEmployerNew></ModalEmployerNew>
          </div>
        </div>
      </div>

      <div class="card-body">
        <div class="search-row mb-3">
          <div class="form-group search-box item mb-0">
            <label for="paginate" class="mb-0">Search</label>
            <input
              v-model="q"
              type="search"
              class="form-control"
              placeholder="Search ..."
              @keyup.enter="fnSearch()"
            />
          </div>

          <div class="status-box item">
            <label for="paginate" class="mb-0">Status</label>
            <select
              v-model="selectedStatus"
              class="form-control sits_select"
              @change="fnSearch()"
            >
              <option value="">All Status</option>
              <option value="0">In-active</option>
              <option value="1">Active</option>
            </select>
          </div>
          <div class="item">
            <button class="btn btn-sm btn-primary mt-4" @click="fnSearch()">
              Search
            </button>
          </div>
          <div class="item">
            <button class="btn btn-sm btn-primary mt-4" @click="fnClear()">
              Clear
            </button>
          </div>
        </div>
        <div class="table-responsive table-sm">
          <table
            class="
              v-datatable-light
              table table-bordered table-hover table-striped table-center
            "
          >
            <thead>
              <tr>
                <th class="header-item"></th>
                <th class="header-item">
                  <a href="#" @click.prevent="fnChangeSort('id')">Id</a>
                  <span v-if="sort_direction == 'desc' && sort_field == 'id'"
                    >&uarr;</span
                  >
                  <span v-if="sort_direction == 'asc' && sort_field == 'id'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item">
                  <a href="#" @click.prevent="fnChangeSort('legal_name')"
                    >Legal name</a
                  >
                  <span
                    v-if="
                      sort_direction == 'desc' && sort_field == 'legal_name'
                    "
                    >&uarr;</span
                  >
                  <span
                    v-if="sort_direction == 'asc' && sort_field == 'legal_name'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item">
                  <a href="#" @click.prevent="fnChangeSort('trading_as_name')"
                    >Trading name</a
                  >
                  <span
                    v-if="
                      sort_direction == 'desc' &&
                      sort_field == 'trading_as_name'
                    "
                    >&uarr;</span
                  >
                  <span
                    v-if="
                      sort_direction == 'asc' && sort_field == 'trading_as_name'
                    "
                    >&darr;</span
                  >
                </th>
                <th class="header-item">FBT Status</th>
                <th class="header-item">Phone</th>
                <th class="header-item">Acc. Con. first name</th>
                <th class="header-item">Acc. Con. email</th>
                <th class="header-item">Pay. Con. first name</th>
                <th class="header-item">Pay. Con. email</th>
                <th class="header-item">EOY Email</th>
                <th class="header-item">Number Emp.</th>
                <th class="header-item v-th-center">
                  <a href="#" @click.prevent="fnChangeSort('status')">Status</a>
                  <span
                    v-if="sort_direction == 'desc' && sort_field == 'status'"
                    >&uarr;</span
                  >
                  <span v-if="sort_direction == 'asc' && sort_field == 'status'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item v-th-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(row, index) in getEmployerPaginateData.data">
                <tr :key="(row, index)">
                  <td
                    @click="toggle(index)"
                    :class="{ opened: opened.includes(index) }"
                  >
                    <span class="text-info pl-2"
                      ><i class="fas fa-outdent"></i
                    ></span>
                  </td>
                  <td>{{ row.id }}</td>
                  <td>{{ row.legal_name }}</td>
                  <td>
                    {{ row.trading_as_name }}
                  </td>
                  <td>
                    {{ row.fbt_status }}
                  </td>
                  <td>{{ row.main_phone }}</td>
                  <td>
                    {{ row.acc_contact_first_name }}
                  </td>
                  <td>
                    {{ row.acc_contact_email }}
                  </td>
                  <td>
                    {{ row.pay_contact_first_name }}
                  </td>
                  <td>
                    {{ row.pay_contact_email }}
                  </td>

                  <td>
                    {{ row.eoy_fbt_reporting_email }}
                  </td>
                  <td>
                    {{ row.number_of_employee }}
                  </td>

                  <td class="v-td-center">
                    <div v-if="row.status == 0">
                      <span class="badge bdg-draft">In-active</span>
                    </div>
                    <div v-if="row.status == 1">
                      <span class="badge bdg-new">Active</span>
                    </div>
                  </td>

                  <td class="v-td-center">
                    <div class="d-flex">
                      <ModalEmployerEdit :propsData="row"></ModalEmployerEdit>
                    </div>
                  </td>
                </tr>

                <!-- Expandable section -->
                <tr v-if="opened.includes(index)">
                  <td colspan="15">
                    <div class="row mr-2 ml-2">
                      <div class="col-lg-4 col-md-4 col-12">
                        <dl class="row">
                          <dt class="col-sm-12 text-info">Company</dt>
                          <dt class="col-sm-5">ABN</dt>
                          <dd class="col-sm-7 mb-0">{{ row.abn }}</dd>
                          <dt class="col-sm-5">Unit number</dt>
                          <dd class="col-sm-7 mb-0">
                            {{ row.address_unit_number }}
                          </dd>
                          <dt class="col-sm-5">Street name</dt>
                          <dd class="col-sm-7 mb-0">
                            {{ row.address_street_name }}
                          </dd>
                          <dt class="col-sm-5">Suburb</dt>
                          <dd class="col-sm-7 mb-0">
                            {{ row.address_suburb }}
                          </dd>
                          <dt class="col-sm-5">State</dt>
                          <dd class="col-sm-7 mb-0">
                            {{ row.address_state }}
                          </dd>
                          <dt class="col-sm-5">Postcode</dt>
                          <dd class="col-sm-7 mb-0">
                            {{ row.address_postcode }}
                          </dd>
                        </dl>

                        <dl class="row">
                          <dt class="col-sm-12 text-info">Postal Address</dt>
                          <dt class="col-sm-5">Unit number</dt>
                          <dd class="col-sm-7 mb-0">
                            {{ row.post_address_unit_number }}
                          </dd>
                          <dt class="col-sm-5">Street name</dt>
                          <dd class="col-sm-7 mb-0">
                            {{ row.post_address_street_name }}
                          </dd>
                          <dt class="col-sm-5">Suburb</dt>
                          <dd class="col-sm-7 mb-0">
                            {{ row.post_address_suburb }}
                          </dd>
                          <dt class="col-sm-5">State</dt>
                          <dd class="col-sm-7 mb-0">
                            {{ row.post_address_state }}
                          </dd>
                          <dt class="col-sm-5">Postcode</dt>
                          <dd class="col-sm-7 mb-0">
                            {{ row.post_address_postcode }}
                          </dd>
                        </dl>
                      </div>

                      <div class="col-lg-4 col-md-4 col-12">
                        <dl class="row">
                          <dt class="col-sm-12 text-info">Bank</dt>
                          <dt class="col-sm-5">BSB</dt>
                          <dd class="col-sm-7 mb-0">{{ row.bank_bsb }}</dd>
                          <dt class="col-sm-5">Account number</dt>
                          <dd class="col-sm-7 mb-0">
                            {{ row.bank_account_number }}
                          </dd>
                          <dt class="col-sm-5">Account name</dt>
                          <dd class="col-sm-7 mb-0">
                            {{ row.bank_account_name }}
                          </dd>
                        </dl>

                        <dl class="row">
                          <dt class="col-sm-12 text-info">
                            Accounts Department
                          </dt>
                          <dt class="col-sm-5">Last name</dt>
                          <dd class="col-sm-7 mb-0">
                            {{ row.acc_contact_last_name }}
                          </dd>
                          <dt class="col-sm-5">Position</dt>
                          <dd class="col-sm-7 mb-0">
                            {{ row.acc_contact_position }}
                          </dd>
                          <dt class="col-sm-5">Phone</dt>
                          <dd class="col-sm-7 mb-0">
                            {{ row.acc_contact_phone }}
                          </dd>
                        </dl>

                        <dl class="row">
                          <dt class="col-sm-12 text-info">
                            Marketing Department
                          </dt>

                          <dt class="col-sm-5">First name</dt>
                          <dd class="col-sm-7 mb-0">
                            {{ row.mar_contact_first_name }}
                          </dd>

                          <dt class="col-sm-5">Last name</dt>
                          <dd class="col-sm-7 mb-0">
                            {{ row.mar_contact_last_name }}
                          </dd>
                          <dt class="col-sm-5">Position</dt>
                          <dd class="col-sm-7 mb-0">
                            {{ row.mar_contact_position }}
                          </dd>
                          <dt class="col-sm-5">Email</dt>
                          <dd class="col-sm-7 mb-0">
                            {{ row.mar_contact_email }}
                          </dd>
                          <dt class="col-sm-5">Phone</dt>
                          <dd class="col-sm-7 mb-0">
                            {{ row.mar_contact_phone }}
                          </dd>
                        </dl>
                      </div>
                      <div class="col-lg-4 col-md-4 col-12">
                        <dl class="row">
                          <dt class="col-sm-12 text-info">
                            Payroll Department
                          </dt>
                          <dt class="col-sm-5">Last name</dt>
                          <dd class="col-sm-7 mb-0">
                            {{ row.pay_contact_last_name }}
                          </dd>
                          <dt class="col-sm-5">Position</dt>
                          <dd class="col-sm-7 mb-0">
                            {{ row.pay_contact_position }}
                          </dd>
                          <dt class="col-sm-5">Phone</dt>
                          <dd class="col-sm-7 mb-0">
                            {{ row.pay_contact_phone }}
                          </dd>
                        </dl>

                        <dl class="row">
                          <dt class="col-sm-12 text-info">Pay cycle details</dt>
                          <dt class="col-sm-5">Pay Cycle</dt>
                          <dd class="col-sm-7 mb-0">
                            {{ row.pay_cycle.toString() }}
                          </dd>
                          <dt class="col-sm-5">Pay Day (if wkly or ftntly):</dt>
                          <dd class="col-sm-7 mb-0">
                            {{ row.pay_day }}
                          </dd>
                          <dt class="col-sm-5">Date (if mthly)</dt>
                          <dd class="col-sm-7 mb-0">
                            {{ row.pay_date }}
                          </dd>

                          <dt class="col-sm-5">Date of First Period End</dt>
                          <dd class="col-sm-7 mb-0">
                            {{ row.pay_date_of_first_period_end }}
                          </dd>
                          <dt class="col-sm-5">Date of First Payday</dt>
                          <dd class="col-sm-7 mb-0">
                            {{ row.pay_date_of_first_pay_day }}
                          </dd>
                          <dt class="col-sm-5">Email for Tax Invoices</dt>
                          <dd class="col-sm-7 mb-0">
                            {{ row.pay_email_for_tax_invoice }}
                          </dd>
                        </dl>

                        <dl class="row">
                          <dt class="col-sm-5">Created date</dt>
                          <dd class="col-sm-7 mb-0">{{ row.created_at }}</dd>
                          <dt class="col-sm-5">Last updated date</dt>
                          <dd class="col-sm-7 mb-0">{{ row.updated_at }}</dd>
                          <dt class="col-sm-5">Created by</dt>
                          <dd class="col-sm-7 mb-0">{{ row.created_by }}</dd>
                          <dt class="col-sm-5">Updated by</dt>
                          <dd class="col-sm-7 mb-0">{{ row.edited_by }}</dd>
                        </dl>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>

              <!-- Pagination -->
              <tr>
                <td colspan="15">
                  <div class="sits-pagination-row">
                    <div class="items-per-page">
                      <div class="pr-2">
                        <p class="mb-0">Items per page</p>
                      </div>
                      <div class="pr-5">
                        <select
                          v-model="recordsPerPage"
                          class="form-control sits_select"
                          @change="fnRecordsPerPage()"
                        >
                          <option value="10">10</option>
                          <option value="15">15</option>
                          <option value="20">20</option>
                          <option value="30">30</option>
                          <option value="40">40</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>

                    <div>
                      <pagination
                        :limit="5"
                        :data="getEmployerPaginateData"
                        @pagination-change-page="fnGetQuoteList"
                      ></pagination>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pagination from 'laravel-vue-pagination'
import { mapGetters, mapActions } from 'vuex'
import ModalEmployerNew from '../../../components/employer/ModalEmployerNew.vue'
import ModalEmployerEdit from '../../../components/employer/ModalEmployerEdit.vue'

export default {
  name: 'employerList',
  components: {
    pagination,
    ModalEmployerNew,
    ModalEmployerEdit
  },
  data() {
    return {
      isDataFetch: true,
      opened: [],
      quoteList: {},
      recordsPerPage: 15,
      page: 1,
      q: '',
      selectedStatus: '',
      sort_direction: 'asc',
      sort_field: 'id',
      paginate: {
        dealerUserId: '',
        page: 1,
        recordsPerPage: 15,
        q: '',
        selectedStatus: '',
        sort_direction: 'asc',
        sort_field: 'id'
      }
    }
  },
  computed: {
    ...mapGetters(['getEmployerPaginateData', 'getEmployerPaginate'])
  },
  methods: {
    ...mapActions(['fetchEmployerPaginate']),
    toggle(id) {
      const index = this.opened.indexOf(id)
      if (index > -1) {
        this.opened.splice(index, 1)
      } else {
        this.opened.push(id)
      }
    },

    fnGetQuoteList: async function (page = 1) {
      let obj1 = this.paginate
      let obj2 = {
        page: page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchEmployerPaginate(objNew)
    },

    fnRecordsPerPage() {
      let obj1 = this.paginate
      let obj2 = {
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }

      this.fetchEmployerPaginate(objNew)
    },

    fnSearch() {
      let obj1 = this.paginate
      let obj2 = {
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchEmployerPaginate(objNew)
    },

    fnChangeSort(field) {
      if (this.sort_field == field) {
        this.sort_direction = this.sort_direction == 'asc' ? 'desc' : 'asc'
      } else {
        this.sort_field = field
      }
      let obj1 = this.paginate
      let obj2 = {
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchEmployerPaginate(objNew)
    },

    fnClear() {
      this.q = ''
      this.selectedStatus = ''
      let obj1 = this.paginate
      let obj2 = {
        page: 1,
        recordsPerPage: 15,
        q: '',
        selectedStatus: '',
        sort_direction: 'asc',
        sort_field: 'id'
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchEmployerPaginate(objNew)
    }
  },

  async mounted() {
    this.isDataFetch = true
    let obj1 = this.paginate
    let obj2 = {
      page: 1,
      recordsPerPage: 15,
      q: '',
      selectedStatus: '',
      sort_direction: 'asc',
      sort_field: 'id'
    }
    let objNew = { ...obj1, ...obj2 }
    await this.fetchEmployerPaginate(objNew)
    this.isDataFetch = false
  }
}
</script>

<style lang="scss" scoped>
.search-row {
  display: flex;
  // justify-content: space-between;
  gap: 20px;
  .search-box {
    width: 450px;
  }
  .status-box {
    width: 250px;
  }

  .item {
    align-self: center;
  }
}

.sits-pagination-row {
  display: flex;
  gap: 10px;
  align-items: baseline;
  padding-top: 5px;
  padding-bottom: 5px;

  .items-per-page {
    display: flex;
    align-items: baseline;
  }

  ul.pagination {
    margin-bottom: 0;
  }

  .page-item.active .page-link {
    z-index: 3;
    color: #fff;
    background-color: red;
    border-color: red;
  }
}
</style>
